var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1651_139609",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1651_139609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C9.68333 21.4167 7.77083 20.0875 6.2625 18.0125C4.75417 15.9375 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 13.6333 19.2458 15.9375 17.7375 18.0125C16.2292 20.0875 14.3167 21.4167 12 22ZM12 19.9C13.7333 19.35 15.1667 18.25 16.3 16.6C17.4333 14.95 18 13.1167 18 11.1V6.375L12 4.125L6 6.375V11.1C6 13.1167 6.56667 14.95 7.7 16.6C8.83333 18.25 10.2667 19.35 12 19.9ZM12 17C12.2833 17 12.5292 16.8958 12.7375 16.6875C12.9458 16.4792 13.05 16.2333 13.05 15.95C13.05 15.6667 12.9458 15.4208 12.7375 15.2125C12.5292 15.0042 12.2833 14.9 12 14.9C11.7167 14.9 11.4708 15.0042 11.2625 15.2125C11.0542 15.4208 10.95 15.6667 10.95 15.95C10.95 16.2333 11.0542 16.4792 11.2625 16.6875C11.4708 16.8958 11.7167 17 12 17ZM11.275 13.8H12.775V13.25C12.775 13.0667 12.8167 12.8917 12.9 12.725C13 12.4917 13.1333 12.2958 13.3 12.1375C13.4667 11.9792 13.6417 11.8167 13.825 11.65C14.1083 11.3667 14.3542 11.05 14.5625 10.7C14.7708 10.35 14.875 9.96667 14.875 9.55C14.875 8.8 14.5875 8.1875 14.0125 7.7125C13.4375 7.2375 12.7667 7 12 7C11.3333 7 10.7375 7.19167 10.2125 7.575C9.6875 7.95833 9.33333 8.46667 9.15 9.1L10.5 9.65C10.6 9.31667 10.7875 9.03333 11.0625 8.8C11.3375 8.56667 11.65 8.45 12 8.45C12.3667 8.45 12.6875 8.55833 12.9625 8.775C13.2375 8.99167 13.375 9.26667 13.375 9.6C13.375 9.88333 13.2875 10.1458 13.1125 10.3875C12.9375 10.6292 12.7417 10.85 12.525 11.05C12.325 11.2333 12.125 11.4208 11.925 11.6125C11.725 11.8042 11.5667 12.025 11.45 12.275C11.3333 12.5083 11.275 12.7542 11.275 13.0125V13.8Z",
    fill: "#3F25AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldQuestion);
export default __webpack_public_path__ + "static/media/shield_question.6e99ea21d1b0afcd3b9dfda5812c000a.svg";
export { ForwardRef as ReactComponent };